module.exports = __webpack_public_path__ + "images/FUSA_icons/034-credit-card-4.1d7621eb09edc91ef4f24e7e9a541982.svg";